import {SelectOptions} from '../../Common/Components/Selects'
import {NotificationOrder} from './Types'

export enum NotificationChannels {
    SMS = 'SMS',
    EMAIL = 'Email',
    MOBILE_PUSH = 'MobilePush',
    BROWSER_PUSH = 'BrowserPush',
}

export enum UserNotificationTypes {
    THRESHOLD = 'threshold',
    STATUS = 'status',
}

export enum NotificationIconTypes {
    ADD = 'add',
    ENABLE = 'enable',
    DISABLE = 'disable',
}

export enum NotificationNames {
    MissedCalls = 'MissedCalls',
    BusyTime = 'BusyTime',
    UserNeverLoggedIn = 'UserNeverLoggedIn',
    UserNotLoggedIn7Days = 'UserNotLoggedIn7Days',
    WeeklyInsightsReport = 'WeeklyInsightsReport',
    AvgAnswerTime = 'AvgAnswerTime',
}

export enum NotificationsModalID {
    NOTIFICATIONS,
    UserNotifications,
}

export enum NotificationPushServiceTypes {
    FCM = 'FCM',
}

export enum NotificationPermissions {
    GRANTED = 'granted',
    DENIED = 'denied',
}

export const USER_NOTIFICATION: string = 'UserNotification'
export const NOTIFICATION_NAME: string = 'NotificationName'
export const NONE_SELECT: string = '[None Selected]'
export const FIREBASE_VAPIDKEY: string =
    'BKjR7_nrWF1YMlSciN-B89myUz9K6QVwu2YgaAJqbU0cmxXOGB-_b2yQzYYt4PCT_GjIbo7hsbY5DoAbG8K16Uc'
export const DEVICE_ALL: string = 'All'

export const firebaseConfig: Record<string, string> = {
    apiKey: 'AIzaSyBJqE8lTMe82rH51GkUI9awwg9GHeynHAc',
    authDomain: 'akixi-39643.firebaseapp.com',
    projectId: 'akixi-39643',
    storageBucket: 'akixi-39643.appspot.com',
    messagingSenderId: '94710163079',
    appId: '1:94710163079:web:72163a976da3f06f823a22',
}

export const notificationOrder: NotificationOrder[] = [
    {
        name: NotificationNames.BusyTime,
        enabledChannels: [NotificationChannels.EMAIL, NotificationChannels.BROWSER_PUSH],
        showHelpText: true,
        modified: undefined,
    },
    {
        name: NotificationNames.MissedCalls,
        enabledChannels: [NotificationChannels.EMAIL, NotificationChannels.BROWSER_PUSH],
        showHelpText: true,
        modified: undefined,
    },
    {
        name: NotificationNames.AvgAnswerTime,
        enabledChannels: [NotificationChannels.EMAIL, NotificationChannels.BROWSER_PUSH],
        showHelpText: true,
        modified: true,
        modifyFunction: (value: number) => value / 1000,
        unModifyFunction: (value: number) => value * 1000,
    },
    {
        name: NotificationNames.WeeklyInsightsReport,
        enabledChannels: [NotificationChannels.EMAIL],
        showHelpText: true,
        modified: undefined,
    },
    {
        name: NotificationNames.UserNotLoggedIn7Days,
        enabledChannels: [NotificationChannels.EMAIL],
        showHelpText: false,
        modified: undefined,
    },
]

export const notificationChannels: SelectOptions<number> = [
    {
        label: 'Email',
        value: 1,
    },
    {
        label: 'Browser Push',
        value: 4,
    },
]

export const notificationChannelsMapToString: Record<number, string> = {
    1: NotificationChannels.EMAIL,
    4: NotificationChannels.BROWSER_PUSH,
}

export const notificationChannelsMapToNum: Record<string, number> = {
    [NotificationChannels.EMAIL]: 1,
    [NotificationChannels.BROWSER_PUSH]: 4,
}

export const excludedNotifications: string[] = [
    NotificationNames.UserNeverLoggedIn,
    NotificationNames.BusyTime,
]
